import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  addFieldData,
  removeStepChildren,
  setItemBreadcrumbs,
  setReturnedValue,
  stopLoading
} from "../../actions";
import { getConsigns, saveAppointment } from "../../utils/appointment";
import { translator } from "../../utils/i18n";
import { getPractitionerById } from "../../utils/practitioner";
import Tooltip from "@material-ui/core/Tooltip";
import { nextAppointments } from "../../utils/scenario/scnr2-fetcher";
import { DateTime } from "luxon";
import * as CalendarHelper from "../../utils/calendar";
import { DATE_FORMAT_INTL } from "../../utils/constants";
import CustomScroll from "react-custom-scroll";
import "react-custom-scroll/dist/customScroll.css";
// import * as ReactGA from "react-ga";
import AlertDialog from "../AlertDialog";
import VideocamIcon from "@material-ui/icons/Videocam";
import Moment from "moment";
import { getReturnedValue } from "../../utils/fetcher";
import AlertConsigns from "../AlertConsigns";

class ListAppointment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      appointment: "",
      fullAppointment: {},
      date: DateTime.local(),
      consigns: [],
      canPrevious: false
    };
    this.originalActiveStep = {};
  }

  componentDidMount() {
    this.originalActiveStep = { ...this.props.activeStep };
    this.props.step.data.fetchSource &&
      this.props.fetchData(this.props.step.data.fetchSource);

    if (this.state.consigns.length === 0) {
      const nowDate = Moment().format("YYYY-MM-DD");
      getConsigns(
        getReturnedValue("appointmentType"),
        getReturnedValue("appointmentLocation"),
        nowDate,
        getReturnedValue("practitioner"),
        true
      ).then(consigns => {
        this.props.stopLoading();
        if (consigns.length > 0) {
          this.setState({
            consigns: consigns,
            fullAppointment: {}
          });
        }
      });
    }
  }

  componentWillUnmount() {
    const dataKey = this.props.step.data.keyValue;
    this.props.resetData(dataKey);
    this.props.removeStepChildren(this.originalActiveStep);
  }

  handleCloseConsigns = () => {
    this.setState({ consigns: [] });
  };

  getData = date => {
    const stepData = this.props.step.data;
    const dataKey = stepData.keyValue;
    if (this.props.dataSource && this.props.dataSource[dataKey]) {
      let data = this.props.dataSource[dataKey];
      if (data) {
        if (Object.values(data)[0].success === 0 && stepData.formatNoSource) {
          data = stepData.formatNoSource(data, date);
        } else if (stepData.formatSource) {
          const keys = Object.keys(data);
          keys.forEach(key => {
            data[key].forEach((elem, index) => {
              const parsedId = elem.id.split("-");
              const locationId = parsedId[6];
              const appointmentType = parsedId[8];
              data[key][index]["locationId"] = locationId;
              data[key][index]["appointmentTypeId"] = appointmentType;
            });
          });
          data = stepData.formatSource(data, date);
        }
      }
      return data;
    }
    if (this.props.message) {
      return this.props.message;
    }
    return null;
  };

  handleValidateConsigns = () => {
    this.setState({ consigns: [] });
    if (this.state.appointment !== "") {
      const helpRdv =
        this.state.fullAppointment.infordvaide &&
        this.state.fullAppointment.infordvaide.decoupe_rdvfils
          ? this.state.fullAppointment.infordvaide.decoupe_rdvfils
          : "";
      this.props.setReturnedValue({
        appointment: this.state.appointment,
        rdvHelp: helpRdv
      });
      this.buildBreadcrumbs(this.state.fullAppointment.date);
      this.props.saveAppointment(this.state.fullAppointment);
    }
  };

  handleAppointmentClick = (event, appointment, date) => {
    const helpRdv =
      appointment.infordvaide && appointment.infordvaide.decoupe_rdvfils
        ? appointment.infordvaide.decoupe_rdvfils
        : "";
    const appointmentDate = Moment(appointment.dateaff, "DD/MM/YYYY").format(
      "YYYY-MM-DD"
    );
    getConsigns(
      appointment.appointmentTypeId,
      appointment.locationId,
      appointmentDate,
      appointment.id_long
    ).then(consigns => {
      this.props.stopLoading();
      if (consigns.length > 0) {
        this.setState({
          consigns: consigns,
          fullAppointment: appointment,
          appointment: appointment.id
        });
      } else {
        this.props.setReturnedValue({
          appointment: appointment.id,
          rdvHelp: helpRdv
        });
        this.buildBreadcrumbs(date);
        this.setState({ appointment: appointment.id });
        this.props.saveAppointment(appointment);
      }
    });
  };

  buildBreadcrumbs = value => {
    const element = { textItem: value, stepItem: { ...this.props.activeStep } };
    this.props.setBreadcrumbs(element);
  };

  getRenderCalendar = data => {
    const nbPeople = parseInt(this.props.returnedValue.nbPeople);
    let textPeople =
      nbPeople > 1
        ? `${translator()._("W_POUR")} ${nbPeople} ${translator()._(
            "W_STEP4_BAS_LIST_PERSONNES"
          )}`
        : "";
    return (
      <div className="wrap-appointments-day">
        {data &&
          data.map((item, key) => {
            return (
              <div key={key} className="appointments-day">
                <div className="title">
                  <strong>{item.weekDay}</strong>
                  {item.date}
                </div>
                {item.list && (
                  <CustomScroll heightRelativeToParent="153px">
                    {item.list.map((itemHour, keyHour) => {
                      let textSecondary =
                        itemHour.activ_remplacant === "ok"
                          ? textPeople +
                            " " +
                            translator()._("CP_AVEC") +
                            " " +
                            itemHour.medecin +
                            " " +
                            translator()._("W_REMPLACANT") +
                            " " +
                            itemHour.nom_docteur_ref_princ
                          : textPeople;
                      if (this.props.returnedValue.practitioner === 0) {
                        textSecondary =
                          itemHour.activ_remplacant === "ok"
                            ? textPeople +
                              " " +
                              translator()._("CP_AVEC") +
                              " " +
                              itemHour.medecin +
                              " " +
                              translator()._("W_REMPLACANT") +
                              " " +
                              itemHour.nom_docteur_ref_princ
                            : textPeople +
                              " " +
                              translator()._("CP_AVEC") +
                              " " +
                              itemHour.medecin;
                      }
                      return (
                        <Tooltip
                          key={keyHour}
                          title={textSecondary}
                          placement="left-end"
                          className="item"
                        >
                          <div
                            onClick={event =>
                              this.handleAppointmentClick(
                                event,
                                itemHour,
                                itemHour.date
                              )
                            }
                          >
                            {itemHour.heureaff_patient}
                            {nbPeople > 1 && (
                              <span className="nb-person">{nbPeople}</span>
                            )}
                            {itemHour.activ_remplacant === "ok" && (
                              <span className="substitute">r</span>
                            )}
                          </div>
                        </Tooltip>
                      );
                    })}
                  </CustomScroll>
                )}
              </div>
            );
          })}
      </div>
    );
  };

  toAppointments = (date = null) => {
    // ReactGA.event({
    //   category: "Calendrier",
    //   action: "Choisir une autre date",
    //   label: "Choisir une autre date de rendez-vous"
    // });
    let _canPrevious = true;
    // click on previous
    if (date === null) {
      // no more date available on the stack (aka first date)
      // so we stop call to API, maybe we need to "block" previous button
      if (CalendarHelper.size() === 0) {
        _canPrevious = false;
        return;
      }
      // when we arrive to first date we need to pop/add it to keep the "beginning" date
      // but we need to "block“ the previous button too
      if (CalendarHelper.size() === 1) {
        date = CalendarHelper.pop();
        _canPrevious = false;

        if (date.diff(this.state.date).toObject().milliseconds === 0) {
          return;
        }
      } else {
        date = CalendarHelper.pop();
        // in case of first click on previous, "poped" date is the same as displayed date
        // so we pop again. Not the more cleaner way to achieve this case
        if (date.diff(this.state.date).toObject().milliseconds === 0) {
          date = CalendarHelper.pop();
        }
      }
    } else {
      // click on next
      CalendarHelper.add(DateTime.fromISO(date));
    }
    date = DateTime.fromISO(date);
    this.setState({ date: date, canPrevious: _canPrevious });
    this.props.nextAppointments(date.toFormat(DATE_FORMAT_INTL));
  };

  editDate = date => {
    date = DateTime.fromISO(new Date(date).toISOString());
    this.setState({ date });
  };

  render() {
    const { step } = this.props;
    const data = this.getData(this.state.date);

    let nextDate = null;
    if (data) {
      const dataValues = Object.values(data);
      nextDate = dataValues[dataValues.length - 1].formattedDate;
      nextDate = nextDate.plus({ days: 1 });
    }

    const practitioner = this.props.returnedValue.practitioner || "";
    const getLabel = () => {
      if (practitioner === "0") {
        return step.label2 || "";
      }
      let practitionerName = "";
      const practitionerDetails = getPractitionerById(practitioner);
      practitionerName = practitionerDetails ? practitionerDetails.libelle : "";

      return (
        <React.Fragment>
          {step.label} <strong>{practitionerName}</strong>
        </React.Fragment>
      );
    };

    return (
      <>
        <div className="multiple-select-custom list-appointment">
          <label className="label">
            {step.icon && <img src={step.icon} alt={step.label} />}
            {getLabel()}
            {this.props.typeConsultation === "teleconsult" && (
              <VideocamIcon className="icon-video" />
            )}
          </label>
          {data && (
            <div className="calendar-appointments">
              <div
                onClick={() => this.state.canPrevious && this.toAppointments()}
                disabled={!this.state.canPrevious}
                className="prev"
              >
                <i className="material-icons">navigate_before</i>
              </div>
              {this.getRenderCalendar(data)}
              <div
                onClick={() => this.toAppointments(nextDate)}
                className="next"
              >
                <i className="material-icons">navigate_next</i>
              </div>
            </div>
          )}
          {data && data[0].success === 0 && data[0].nextDate && (
            <div
              onClick={() => this.toAppointments(data[0].nextDate)}
              className="message-no-appointment"
            >
              {data[0].message}{" "}
              <span className="text-blue date d-block">
                {data[0].dateToShow}
              </span>
            </div>
          )}
          {data && data[0].success === 0 && !data[0].nextDate && (
            <div className="message-no-appointment">{data[0].message}</div>
          )}
        </div>
        {this.props.messageWithCode && this.props.messageWithCode.text && (
          <AlertDialog
            content={this.props.messageWithCode.text}
            isResetAlert={false}
          />
        )}
        {this.state.consigns.length > 0 && (
          <AlertConsigns
            handleClose={() => this.handleCloseConsigns()}
            consigns={this.state.consigns}
            onClick={() => this.handleValidateConsigns()}
            noCancel={this.state.appointment === ""}
          />
        )}
      </>
    );
  }
}

ListAppointment.propTypes = {
  activeStep: PropTypes.any,
  dataSource: PropTypes.any,
  fetchData: PropTypes.func,
  message: PropTypes.any,
  messageWithCode: PropTypes.shape({
    text: PropTypes.any
  }),
  nextAppointments: PropTypes.func,
  removeStepChildren: PropTypes.func,
  resetData: PropTypes.func,
  returnedValue: PropTypes.shape({
    nbPeople: PropTypes.any,
    practitioner: PropTypes.string
  }),
  saveAppointment: PropTypes.func,
  setBreadcrumbs: PropTypes.func,
  setReturnedValue: PropTypes.func,
  step: PropTypes.shape({
    data: PropTypes.shape({
      fetchSource: PropTypes.func,
      formatNoSource: PropTypes.func,
      formatSource: PropTypes.func,
      keyValue: PropTypes.any
    }),
    icon: PropTypes.any,
    label: PropTypes.any,
    label2: PropTypes.string
  }),
  typeConsultation: PropTypes.string,
  stopLoading: PropTypes.func
};

const mapStateToProps = state => {
  return {
    dataSource: state.dataSource,
    activeStep: state.activeStep,
    returnedValue: state.returnedValue,
    message: state.message,
    messageWithCode: state.messageWithCode,
    typeConsultation: state.returnedValue.typeConsultation
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchData: functionName => dispatch(functionName()),
    setReturnedValue: value => dispatch(setReturnedValue(value)),
    saveAppointment: appointment => dispatch(saveAppointment(appointment)),
    setBreadcrumbs: item => dispatch(setItemBreadcrumbs(item)),
    resetData: key => dispatch(addFieldData(key, null)),
    removeStepChildren: activeStep => dispatch(removeStepChildren(activeStep)),
    nextAppointments: date => dispatch(nextAppointments(date)),
    stopLoading: () => dispatch(stopLoading())
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ListAppointment);
